import { useEffect, useRef } from 'react';
import './contentSettingDropDown.css';
import {jwtDecode} from 'jwt-decode';

const tokenData = () => {
    if (localStorage.getItem('loginToken')) {
        const decodedToken = jwtDecode(localStorage.getItem('loginToken'));
        return decodedToken 
    }
    return {}
}

const ContentSettingDropDown = (props) => {
    let logoutRef = useRef();
    useEffect(() => {
		let logoutHandler = (e)=> {
			if(logoutRef.current.contains(e.target)){
				props.updateIsLoggedIn(false);
                localStorage.removeItem('loginToken');
			}
			
		};
		document.addEventListener("mousedown", logoutHandler);
		return () => {document.removeEventListener("mousedown", logoutHandler);}
	});
	return (
        //onClick={setToggleSetting.bind(this, false)}

        <div className="settingDropDown" >
            <div  className="settingDropDown-body">
                <div>
                    <span className="material-symbols-outlined">settings</span>
                    <label htmlFor="c1-13">Setting</label>
                </div>
                <div>
                    <span className="material-symbols-outlined">person</span>
                    <label htmlFor="c1-13">Profile</label>
                </div>
                <hr />
                <div ref={logoutRef}>
                    <span className="material-symbols-outlined">logout</span>
                    <label htmlFor="c1-13">Sign out</label>
                </div>
                <div>
                    <label className="settingDropDownName">{tokenData().result.full_name}<br/>{tokenData().result.type.charAt(0).toUpperCase()+tokenData().result.type.slice(1) }</label>
                </div>       
            </div>
            
            
        </div>
    )
}   

export default ContentSettingDropDown;

